/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PresignedPostResponse } from '../housien-models/PresignedPostResponse';
import type { SuccessResponse } from '../housien-models/SuccessResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPIHousien } from '../core/OpenAPI';
import { request as __request } from '../core/request';

/**
 * Requests a presigned S3 POST for uploading an agency logo via
 * `GET /agencies/{agencyId}/logo`.
 *
 * @param agencyId - The agency identifier
 * @returns A cancelable promise resolving to the presigned upload target
 */
export function generateAgencyLogoUploadUrl(
agencyId: string,
): CancelablePromise<PresignedPostResponse> {
    return __request(OpenAPIHousien, {
        method: 'GET',
        url: '/agencies/{agencyId}/logo',
        path: {
            'agencyId': agencyId,
        },
    });
}

/**
 * Deletes the agency logo via `DELETE /agencies/{agencyId}/logo`.
 *
 * @param agencyId - The agency identifier
 * @returns A cancelable promise resolving to the deletion message payload
 */
/**
 * Deletes an agency's logo via `DELETE /agencies/{agencyId}/logo`.
 *
 * @param agencyId - The agency identifier
 * @returns A cancelable promise resolving to a deletion confirmation message
 */
export function deleteAgencyLogo(
agencyId: string,
): CancelablePromise<{
message?: string;
}> {
    return __request(OpenAPIHousien, {
        method: 'DELETE',
        url: '/agencies/{agencyId}/logo',
        path: {
            'agencyId': agencyId,
        },
    });
}

/**
 * Retrieves a presigned view URL for the agency logo via
 * `GET /agencies/{agencyId}/logo/view`.
 *
 * @param agencyId - The agency identifier
 * @returns A cancelable promise resolving to the `{ url }` view payload
 */
/**
 * Retrieves a viewable (presigned) URL for an agency's logo via
 * `GET /agencies/{agencyId}/logo/view`.
 *
 * @param agencyId - The agency identifier
 * @returns A cancelable promise resolving to the logo view URL
 */
export function getAgencyLogoViewUrl(
agencyId: string,
): CancelablePromise<{
url?: string;
}> {
    return __request(OpenAPIHousien, {
        method: 'GET',
        url: '/agencies/{agencyId}/logo/view',
        path: {
            'agencyId': agencyId,
        },
    });
}

/**
 * Retrieves the agency's role-to-permission map via
 * `GET /agencies/{agencyId}/permissions`.
 *
 * @param agencyId - The agency identifier
 * @returns A cancelable promise resolving to a map of role to permission list
 */
/**
 * Fetches the agency's role-to-permission map via
 * `GET /agencies/{agencyId}/permissions`.
 *
 * @param agencyId - The agency identifier
 * @returns A cancelable promise resolving to a map of role to permission list
 */
export function getAgencyPermissions(
agencyId: string,
): CancelablePromise<Record<string, string[]>> {
    return __request(OpenAPIHousien, {
        method: 'GET',
        url: '/agencies/{agencyId}/permissions',
        path: {
            'agencyId': agencyId,
        },
    });
}

/**
 * Replaces the agency's role-to-permission map via
 * `PUT /agencies/{agencyId}/permissions`.
 *
 * @param agencyId - The agency identifier
 * @param requestBody - The role-to-permission map to persist
 * @returns A cancelable promise resolving to the update success response
 */
/**
 * Updates the agency's role-to-permission map via
 * `PUT /agencies/{agencyId}/permissions`.
 *
 * @param agencyId - The agency identifier
 * @param requestBody - The new role-to-permission mapping to persist
 * @returns A cancelable promise resolving to the operation result
 */
export function updateAgencyPermissions(
agencyId: string,
requestBody: Record<string, string[]>,
): CancelablePromise<SuccessResponse> {
    return __request(OpenAPIHousien, {
        method: 'PUT',
        url: '/agencies/{agencyId}/permissions',
        path: {
            'agencyId': agencyId,
        },
        body: requestBody,
        mediaType: 'application/json',
    });
}
